import { Box } from '@mui/material';
import React from 'react';

import { CockpitButton } from '../../../components';
import { useCockpitAccess } from '../../../hooks';

const styles = {
  watchlistHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 4,
    mb: 5,
    px: { lg: 6 },
  },
};

export const WatchlistHeader: React.FC = () => {
  const { isCockpitAccessEnabled } = useCockpitAccess();

  return (
    <Box className="watchlist-header" sx={styles.watchlistHeader}>
      {isCockpitAccessEnabled && <CockpitButton />}
    </Box>
  );
};

WatchlistHeader.displayName = 'WatchlistHeader';
